import call from "./call";
import {
  DashboardActivityResponse,
  DashboardModuleKey,
  DashboardSearchResponse,
  ModulePreferencesResponse,
  RecentItemsResponse,
} from "../Models/dashboard";

export const getModulePreferences =
  async (): Promise<ModulePreferencesResponse> => {
    const { data } = await call.get("/v1/dashboard/modules/");
    return data;
  };

export const setModuleFavorite = async (
  moduleKey: DashboardModuleKey,
  isFavorite: boolean,
): Promise<ModulePreferencesResponse> => {
  const { data } = await call.put(
    `/v1/dashboard/modules/${moduleKey}/favorite/`,
    { is_favorite: isFavorite },
    { snack: { error: "dashboard.favoriteError" } },
  );
  return data;
};

// Fire-and-forget bookkeeping, so it never shows a snackbar.
export const markModuleOpened = async (
  moduleKey: DashboardModuleKey,
): Promise<ModulePreferencesResponse> => {
  const { data } = await call.post(
    `/v1/dashboard/modules/${moduleKey}/opened/`,
  );
  return data;
};

export const searchDashboard = async (
  query: string,
  signal?: AbortSignal,
): Promise<DashboardSearchResponse> => {
  const { data } = await call.get("/v1/dashboard/search/", {
    params: { q: query },
    signal,
  });
  return data;
};

export const getRecentItems = async (
  limit: number,
): Promise<RecentItemsResponse> => {
  const { data } = await call.get("/v1/dashboard/recent/", {
    params: { limit },
  });
  return data;
};

export const getDashboardActivity = async (
  days: number,
): Promise<DashboardActivityResponse> => {
  const { data } = await call.get("/v1/dashboard/activity/", {
    params: { days },
  });
  return data;
};
